// The final chapter ends at the page's reachable scroll limit, including the
// footer. Its own height can extend beyond where its top can ever be scrolled.
export function chapterReadingPosition(chapters, scrollY, maxScroll, offset) {
  if (!chapters.length) return { id: '', progress: 0 };
  if (maxScroll > 0 && scrollY >= maxScroll - 2) return { id: chapters.at(-1).id, progress: 1 };
  let index = 0;
  for (let i = 0; i < chapters.length; i += 1) {
    if (chapters[i].top - offset <= scrollY + 1) index = i;
  }
  const start = Math.max(0, chapters[index].top - offset);
  const end = Math.min(maxScroll, chapters[index + 1] ? chapters[index + 1].top - offset : maxScroll);
  return { id: chapters[index].id, progress: Math.max(0, Math.min(1, (scrollY - start) / Math.max(1, end - start))) };
}
